<template>

    <div>

        <h1 class="legal-heading">Datenschutzerklärung</h1>

        <p class="legal-sub">Gemäß DSGVO (EU 2016/679) und österreichischem Datenschutzgesetz (DSG)</p>

        <div class="legal-block">

            <h2 class="legal-section-title">Verantwortlicher</h2>

            <p>
                Daniel Wiesner<br>
                WIESNERD Daniel Wiesner<br>
                Tulpenweg 3, 5121 St. Radegund<br>
                E-Mail: <a href="mailto:office@wiesnerd.at">office@wiesnerd.at</a>
            </p>

        </div>

        <div class="legal-block">

            <h2 class="legal-section-title">Welche Daten werden verarbeitet?</h2>

            <h3 class="legal-subsection-title">Beim Besuch der Webseite</h3>

            <p>
                Beim Aufruf der Webseite werden durch den Webserver automatisch folgende Daten verarbeitet:
            </p>

            <ul>

                <li>IP-Adresse</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Aufgerufene Seite</li>
                <li>Verwendeter Browser und Betriebssystem</li>

            </ul>

            <p>
                <strong>Zweck:</strong> Technischer Betrieb und Sicherheit der Webseite<br>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)<br>
                <strong>Speicherdauer:</strong> 14 Tage, danach automatische Löschung<br>
                <strong>Weitergabe:</strong> Keine Weitergabe an Dritte
            </p>

            <p>
                Es werden keine Cookies gesetzt und kein Tracking durchgeführt.
            </p>

            <h3 class="legal-subsection-title">Über das Kontaktformular</h3>

            <p>Wenn Sie das Kontaktformular verwenden, werden folgende Daten verarbeitet:</p>

            <ul>

                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Betreff und Nachrichteninhalt</li>

            </ul>

            <p>
                <strong>Zweck:</strong> Bearbeitung Ihrer Anfrage und Kontaktaufnahme<br>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)<br>
                <strong>Speicherdauer:</strong> Bis zur abschließenden Bearbeitung Ihrer Anfrage, danach Löschung sofern keine gesetzliche Aufbewahrungspflicht besteht<br>
                <strong>Weitergabe:</strong> Keine Weitergabe an Dritte
            </p>

            <h3 class="legal-subsection-title">Per E-Mail</h3>

            <p>
                Wenn Sie mir direkt eine E-Mail senden, werden die übermittelten Daten (Absender, Inhalt)
                zur Bearbeitung Ihrer Anfrage gespeichert. Auch hier erfolgt keine Weitergabe an Dritte.
            </p>

        </div>

        <div class="legal-block">

            <h2 class="legal-section-title">Ihre Rechte</h2>

            <p>Sie haben nach DSGVO folgende Rechte:</p>

            <ul>

                <li><strong>Auskunft</strong> (Art. 15 DSGVO): Welche Daten von Ihnen gespeichert sind</li>
                <li><strong>Berichtigung</strong> (Art. 16 DSGVO): Korrektur unrichtiger Daten</li>
                <li><strong>Löschung</strong> (Art. 17 DSGVO): Löschung Ihrer Daten soweit keine Aufbewahrungspflicht besteht</li>
                <li><strong>Einschränkung</strong> (Art. 18 DSGVO): Einschränkung der Verarbeitung</li>
                <li><strong>Widerspruch</strong> (Art. 21 DSGVO): Widerspruch gegen die Verarbeitung</li>
                <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO): Übermittlung Ihrer Daten in einem gängigen Format</li>

            </ul>

            <p>
                Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:
                <a href="mailto:office@wiesnerd.at">office@wiesnerd.at</a>
            </p>

        </div>

        <div class="legal-block">

            <h2 class="legal-section-title">Beschwerderecht</h2>

            <p>Sie haben das Recht, sich bei der österreichischen Datenschutzbehörde zu beschweren:</p>

            <p>
                <strong>Österreichische Datenschutzbehörde</strong><br>
                Barichgasse 40–42, 1030 Wien<br>
                <a href="https://www.dsb.gv.at" target="_blank" rel="noopener">dsb.gv.at</a>
            </p>

        </div>

        <div class="legal-block">

            <h2 class="legal-section-title">Hosting</h2>

            <p>
                Die Webseite wird auf einem eigenen Dedicated Server in einem Rechenzentrum in Deutschland (EU) betrieben.
                Der Serveranbieter stellt ausschließlich die physische Infrastruktur bereit und hat keinen Zugriff
                auf die verarbeiteten Daten. Es findet keine Datenverarbeitung durch Dritte statt.
            </p>

            <p>
                Es werden keine externen Tracking-Dienste, Analyse-Tools, Social-Media-Plugins oder
                Werbenetzwerke eingesetzt.
            </p>

        </div>

        <div class="legal-block">

            <p class="legal-stand">Stand: April 2026</p>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'TheDatenschutzView',

    }

</script>

<style scoped>

    .legal-heading {

        font-size: 1.6rem;
        font-weight: 700;
        color: #1a2a3a;
        margin-bottom: 0.25rem;

    }

    .legal-sub {

        font-size: 0.85rem;
        color: #7a8a9a;
        margin-bottom: 2rem;

    }

    .legal-block {

        margin-bottom: 1.75rem;
        padding-bottom: 1.75rem;
        border-bottom: 1px solid #e4edf5;

    }

    .legal-block:last-child {

        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;

    }

    .legal-section-title {

        font-size: 1.1rem;
        font-weight: 600;
        color: #1a2a3a;
        margin-bottom: 0.75rem;

    }

    .legal-subsection-title {

        font-size: 0.95rem;
        font-weight: 600;
        color: #2a3a4a;
        margin-top: 1.25rem;
        margin-bottom: 0.5rem;

    }

    .legal-block p {

        color: #4a5a6a;
        line-height: 1.7;
        margin-bottom: 0.75rem;

    }

    .legal-block p:last-child {

        margin-bottom: 0;

    }

    .legal-block ul {

        color: #4a5a6a;
        line-height: 1.7;
        padding-left: 1.25rem;
        margin-bottom: 0.75rem;

    }

    .legal-block li {

        margin-bottom: 0.25rem;

    }

    .legal-block a {

        color: #0B5FA5;
        text-decoration: none;

    }

    .legal-block a:hover {

        text-decoration: underline;

    }

    .legal-stand {

        font-size: 0.82rem;
        color: #9aa8b4;

    }

</style>
